// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    overflow: hidden;
}

body {
    margin: 0px !important;
}

.help-desk-launcher.help-desk-style-iframe {
    width: 60px;
    height: 60px;
}

    .help-desk-launcher.help-desk-style-iframe .help-desk-svg1 {
        height: 100%;
        width: 100%;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
    }

        .help-desk-svg1 * {
            cursor: pointer;
        }

.help-desk-svg1 svg {
    width: 28px;
    height: 32px;
}

.help-desk-svg1 img {
    width: 28px;
    height: 32px;
}

.help-desk-launcher-active .help-desk-svg1 {
    opacity: 0;
}

.help-desk-svg2 {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
    opacity: 0;
    transform: rotate(-30deg);
    transition: transform 0.16s linear 0s, opacity 0.08s linear 0s;
}
    .help-desk-svg2 * {
        cursor: pointer;
    }

    .help-desk-svg2 svg {
        width: 14px;
        height: 14px;
    }

      .help-desk-svg2 svg path {
          fill: rgb(255, 255, 255);
      }

.help-desk-launcher-active .help-desk-svg2 {
    opacity: 1;
    transform: rotate(0deg);
}`, "",{"version":3,"sources":["webpack://./dist/src/components/frame/frame-container.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;IAEI;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,yBAAyB;QACzB,mBAAmB;QACnB,wBAAwB;QACxB,uBAAuB;IAC3B;;QAEI;YACI,eAAe;QACnB;;AAER;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,8DAA8D;AAClE;IACI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;MAEE;UACI,wBAAwB;MAC5B;;AAEN;IACI,UAAU;IACV,uBAAuB;AAC3B","sourcesContent":["html {\r\n    overflow: hidden;\r\n}\r\n\r\nbody {\r\n    margin: 0px !important;\r\n}\r\n\r\n.help-desk-launcher.help-desk-style-iframe {\r\n    width: 60px;\r\n    height: 60px;\r\n}\r\n\r\n    .help-desk-launcher.help-desk-style-iframe .help-desk-svg1 {\r\n        height: 100%;\r\n        width: 100%;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        align-items: center;\r\n        -webkit-box-pack: center;\r\n        justify-content: center;\r\n    }\r\n\r\n        .help-desk-svg1 * {\r\n            cursor: pointer;\r\n        }\r\n\r\n.help-desk-svg1 svg {\r\n    width: 28px;\r\n    height: 32px;\r\n}\r\n\r\n.help-desk-svg1 img {\r\n    width: 28px;\r\n    height: 32px;\r\n}\r\n\r\n.help-desk-launcher-active .help-desk-svg1 {\r\n    opacity: 0;\r\n}\r\n\r\n.help-desk-svg2 {\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    align-items: center;\r\n    -webkit-box-pack: center;\r\n    justify-content: center;\r\n    position: absolute;\r\n    top: 0px;\r\n    bottom: 0px;\r\n    width: 100%;\r\n    opacity: 0;\r\n    transform: rotate(-30deg);\r\n    transition: transform 0.16s linear 0s, opacity 0.08s linear 0s;\r\n}\r\n    .help-desk-svg2 * {\r\n        cursor: pointer;\r\n    }\r\n\r\n    .help-desk-svg2 svg {\r\n        width: 14px;\r\n        height: 14px;\r\n    }\r\n\r\n      .help-desk-svg2 svg path {\r\n          fill: rgb(255, 255, 255);\r\n      }\r\n\r\n.help-desk-launcher-active .help-desk-svg2 {\r\n    opacity: 1;\r\n    transform: rotate(0deg);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
